// extracted by mini-css-extract-plugin
export default {"sort":"az-z","sortSelect":"bz-z","disabled":"cz-z"};